export default __webpack_public_path__ + "static/media/LogoMark.5f714c17.png";